import { useEffect, useRef } from 'react';
import type { Message } from '../types';

interface ChatPanelProps {
  messages: Message[];
  onSend: (text: string) => void;
  isProcessing: boolean;
  /** Slot rendered before the text input — used for the voice button */
  inputPrefix?: React.ReactNode;
}

export default function ChatPanel({ messages, onSend, isProcessing, inputPrefix }: ChatPanelProps) {
  const historyRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  // Auto-scroll to bottom on new messages
  useEffect(() => {
    const el = historyRef.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [messages, isProcessing]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const text = inputRef.current?.value.trim();
    if (!text || isProcessing) return;
    onSend(text);
    if (inputRef.current) inputRef.current.value = '';
  };

  return (
    <div className="chat-panel">
      {/* Message history */}
      <div className="chat-history" ref={historyRef}>
        {messages.map((msg) => (
          <div key={msg.id} className={`message-row ${msg.isUser ? 'user' : 'rammux'}`}>
            <div className="message-sender">{msg.isUser ? 'TÚ' : 'RAMMUX'}</div>
            <div className="message-bubble">{msg.text}</div>
          </div>
        ))}

        {isProcessing && (
          <div className="message-row rammux">
            <div className="message-sender">RAMMUX</div>
            <div className="message-bubble processing">PROCESANDO...</div>
          </div>
        )}
      </div>

      {/* Input area */}
      <form className="chat-input-area" onSubmit={handleSubmit}>
        {inputPrefix}
        <input
          ref={inputRef}
          type="text"
          className="chat-input"
          placeholder="Escribe tu mensaje para RAMMUX..."
          autoComplete="off"
          disabled={isProcessing}
        />
        <button type="submit" className="send-btn" disabled={isProcessing} aria-label="Enviar">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="22" y1="2" x2="11" y2="13" />
            <polygon points="22 2 15 22 11 13 2 9 22 2" />
          </svg>
        </button>
      </form>

      <p className="chat-footer">Powered by Webcol.net &amp; n8n AI</p>
    </div>
  );
}
